<template>
  <q-tooltip
    @show="onShow"
    :content-class="`tooltip bg-${bgColor} text-body1 tooltip-arrow-${arrowClass}`"
    ref="tooltipRef"
    :anchor="anchor"
    :self="self"
    :value="display"
    :no-parent-event="noParentEvent"
    :offset="offset"
  >
    <div
      class="tooltip-text text-body1 relative-position text-weight-light"
      :class="`bg-${bgColor} text-${color}`"
    >
      <slot name="default"></slot>
      <slot name="actions">
        <div class="flex justify-end q-pt-sm" v-if="closeable">
          <q-btn @click="closeTooltip" class="tooltip-close align-self-end" :label="closeLabel" flat dense />
        </div>
      </slot>
    </div>
    <div
      class="tooltip-arrow absolute"
      :class="`bg-${bgColor}`"
    />
  </q-tooltip>
</template>

<script>

export default {
  name: 'Tooltip',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: String,
      default: 'top'
    },
    anchor: {
      type: String,
      default: 'bottom middle'
    },
    self: {
      type: String,
      default: 'top middle'
    },
    duration: {
      type: Number,
      default: null
    },
    closeable: {
      type: Boolean,
      default: false
    },
    closeLabel: {
      type: String,
      default: 'Got it'
    },
    bgColor: {
      type: String,
      default: 'blue'
    },
    color: {
      type: String,
      default: 'white'
    },
    noParentEvent: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: () => [14, 14]
    }
  },
  computed: {
    arrowClass () {
      const arrowClassCorrected = this.arrow.replace(' ', '-')
      const allowedClasses = ['top', 'top-left', 'top-right', 'bottom', 'bottom-left', 'bottom-right', 'left', 'left-top', 'left-bottom', 'right', 'right-top', 'right-bottom']
      if (!allowedClasses.includes(arrowClassCorrected)) {
        console.error(`Value "${arrowClassCorrected}" not allowed for "arrow" prop. Use one of these: `, allowedClasses)
        return 'top'
      }

      return this.arrow.replace(' ', '-')
    },
    display: {
      get: function () {
        return this.show
      },
      set: function (value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    onShow () {
      if (this.duration) {
        setTimeout(() => {
          this.display = false
        }, this.duration)
      }
    },
    closeTooltip () {
      this.display = false
      this.$emit('closed')
    }
  }
}
</script>
<style lang="scss">
$box-shadow: 0 0 20px 0 rgba(0,0,0,0.5);

.tooltip {
  box-shadow: $box-shadow;
  overflow: visible;
  border-radius: 10px;
  padding: 0;
  &-text {
    z-index: 10;
    padding: 20px;
    border-radius: 10px;
  }
  &-arrow {
    z-index: 5;
    width: 30px;
    height: 30px;
    box-shadow: $box-shadow;
    transform: translateX(-50%) rotate(-45deg) skew(-20deg, -20deg);

    // top arrows
    [class*="tooltip-arrow-top"] & {
      top: 0;
    }
    .tooltip-arrow-top & {
      left: 50%;
    }
    .tooltip-arrow-top-left & {
      left: 30px;
    }
    .tooltip-arrow-top-right & {
      right: 0;
    }

    // bottom arrows
    [class*="tooltip-arrow-bottom"] & {
      bottom: 0;
    }
    .tooltip-arrow-bottom & {
      left: 50%;
    }
    .tooltip-arrow-bottom-left & {
      left: 30px;
    }
    .tooltip-arrow-bottom-right & {
      right: 0;
    }

    // left arrows
    [class*="tooltip-arrow-left"] & {
      transform: translateY(-50%) rotate(45deg) skew(-20deg, -20deg);
      left: 0;
    }
    .tooltip-arrow-left & {
      top: 50%;
    }
    .tooltip-arrow-left-top & {
      top: 20px;
    }
    .tooltip-arrow-left-bottom & {
      bottom: -10px;
    }

    // right arrows
    [class*="tooltip-arrow-right"] & {
      transform: translateY(-50%) rotate(45deg) skew(-20deg, -20deg);
      right: 0;
    }
    .tooltip-arrow-right & {
      top: 50%;
    }
    .tooltip-arrow-right-top & {
      top: 20px;
    }
    .tooltip-arrow-right-bottom & {
      bottom: -10px;
    }

  }

  // close button
  &-close {
    pointer-events: all !important;
  }
}
</style>
